import React, { useState } from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  Form,
} from 'react-bootstrap';
import { FilterList, Clear } from '@mui/icons-material';
import './OrderFilterComponent.css';

/**
 * Order status filter options based on Quote status
 */
const STATUS_OPTIONS = [
  { value: '', label: 'All Orders' },
  { value: 'fulfilled', label: 'Fulfilled' },
  { value: 'unfulfilled', label: 'Unfulfilled' },
  { value: 'requested', label: 'Requested' },
  { value: 'received', label: 'Received' },
  { value: 'sent_to_supplier', label: 'Sent to Supplier' },
  { value: 'arrived_unfulfilled', label: 'Arrived, Unfulfilled' },
];

/**
 * Component for filtering orders based on status
 * @param {Object} filters - Current filter state
 * @param {Function} setFilters - Function to update filters
 * @param {Function} onApplyFilters - Function to apply filters
 * @param {Function} onClearFilters - Function to clear all filters
 */
const OrderFilterComponent = ({
  filters,
  setFilters,
  onApplyFilters,
  onClearFilters,
}) => {
  const [activeKey, setActiveKey] = useState('0');

  const handleFilterChange = (filterKey, value) => {
    setFilters(prev => ({
      ...prev,
      [filterKey]: value,
    }));
    // Automatically apply filters when they change with the new value
    onApplyFilters(value);
  };

  const handleClearFilters = () => {
    setFilters({
      status: '',
    });
    onClearFilters();
  };

  const hasActiveFilters = Object.values(filters).some(
    value => value !== '' && value !== null && value !== undefined
  );

  return (
    <Card className="mb-3 order-filter-card">
      <Card.Header className="order-filter-header">
        <div className="order-filter-title">
          <FilterList className="order-filter-icon" />
          <strong>Order Filters</strong>
          {hasActiveFilters && (
            <span className="active-filters-indicator">
              {
                Object.values(filters).filter(
                  v => v !== '' && v !== null && v !== undefined
                ).length
              }
            </span>
          )}
        </div>
        {hasActiveFilters && (
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleClearFilters}
            className="clear-filters-btn"
          >
            <Clear className="me-1" />
            Clear All
          </Button>
        )}
      </Card.Header>
      <Card.Body>
        <Accordion activeKey={activeKey} onSelect={key => setActiveKey(key)}>
          {/* Status Filter */}
          <AccordionItem eventKey="0">
            <AccordionHeader>Order Status</AccordionHeader>
            <AccordionBody>
              <Form.Group className="status-options">
                {STATUS_OPTIONS.map(option => (
                  <Form.Check
                    key={option.value}
                    type="radio"
                    label={option.label}
                    name="status"
                    checked={filters.status === option.value}
                    onChange={() => handleFilterChange('status', option.value)}
                  />
                ))}
              </Form.Group>
            </AccordionBody>
          </AccordionItem>
        </Accordion>

        {/* Remove the Apply Filters button since filters are applied automatically */}
      </Card.Body>
    </Card>
  );
};

export default OrderFilterComponent;
